// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/img/dust_scratches.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#tableS-activePivot {
  border-bottom: 3px solid orange;
}
.tableS-selectPivots {
  cursor: pointer;
}
.tableS-helpPivots {
  display: flex;
  justify-content: flex-start;
  margin-left: 2vw;
  gap: 1vw;
  font-family: "Amatic SC";
  font-size: 2vw;
  font-weight: 900;
}
.tableS-icon-transButtons-help {
  display: grid;
  height: 2.2vw;
  width: 100%;
}
.tableS-transButtons-help {
  display: grid;
  column-gap: 1vw;
  row-gap: 0.5vw;
  justify-self: center;
  grid-template-columns: repeat(3, 3.4vw);
}
.tableS-closeButton {
  position: absolute;
  top: 1%;
  left: 1%;
  height: 2.5vw;
  cursor: pointer;
}
.tableS-iconhelp {
  height: 2vw;
  place-content: center;
}

.tableS-next-help {
  filter: brightness(0.8);
}
#tableS-modesCards {
  direction: rtl;
  overflow: auto;
  height: 95%;
}
.tableS-helpPanel {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 31vw;
  padding: 1.5%;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  box-shadow:
    0 4px 8px rgba(0, 0, 0, 0.2),
    0 6px 20px rgba(0, 0, 0, 0.19);
  z-index: 2;
}
.tableS-helpCard {
  position: relative;
  direction: ltr;
  padding: 1vw;
  margin: 1.25vw;
  width: auto;
  border: solid 1px #1a6a7c;
  border-radius: 10px;
  background: #ffffff;
  filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.4));
  font-size: 1.5vw;
}
.tableS-cardCaption {
  font-family: "Amatic SC";
  font-size: 2vw;
}
.tableS-auxButtonshelp {
  display: grid;
  width: 50%;
  grid-template-columns: repeat(3, auto);
  gap: 0.5vw;
  justify-self: center;
}
#tableS-modesCards::-webkit-scrollbar {
  width: 0.5vw;
}

#tableS-modesCards::-webkit-scrollbar-thumb {
  background: #cecece;
}`, "",{"version":3,"sources":["webpack://./src/TaskWindows/TablesSecret/styles/TablesShelppanel.css"],"names":[],"mappings":"AAAA;EACE,+BAA+B;AACjC;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,2BAA2B;EAC3B,gBAAgB;EAChB,QAAQ;EACR,wBAAwB;EACxB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,aAAa;EACb,WAAW;AACb;AACA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,oBAAoB;EACpB,uCAAuC;AACzC;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,aAAa;EACb,eAAe;AACjB;AACA;EACE,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,cAAc;EACd,WAAW;AACb;AACA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,SAAS;EACT,WAAW;EACX,aAAa;EACb,yDAAgE;EAChE;;kCAEgC;EAChC,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EAEnB,mDAAmD;EACnD,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,aAAa;EACb,UAAU;EACV,sCAAsC;EACtC,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["#tableS-activePivot {\n  border-bottom: 3px solid orange;\n}\n.tableS-selectPivots {\n  cursor: pointer;\n}\n.tableS-helpPivots {\n  display: flex;\n  justify-content: flex-start;\n  margin-left: 2vw;\n  gap: 1vw;\n  font-family: \"Amatic SC\";\n  font-size: 2vw;\n  font-weight: 900;\n}\n.tableS-icon-transButtons-help {\n  display: grid;\n  height: 2.2vw;\n  width: 100%;\n}\n.tableS-transButtons-help {\n  display: grid;\n  column-gap: 1vw;\n  row-gap: 0.5vw;\n  justify-self: center;\n  grid-template-columns: repeat(3, 3.4vw);\n}\n.tableS-closeButton {\n  position: absolute;\n  top: 1%;\n  left: 1%;\n  height: 2.5vw;\n  cursor: pointer;\n}\n.tableS-iconhelp {\n  height: 2vw;\n  place-content: center;\n}\n\n.tableS-next-help {\n  filter: brightness(0.8);\n}\n#tableS-modesCards {\n  direction: rtl;\n  overflow: auto;\n  height: 95%;\n}\n.tableS-helpPanel {\n  position: fixed;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  width: 31vw;\n  padding: 1.5%;\n  background-image: url(../../../../public/img/dust_scratches.png);\n  box-shadow:\n    0 4px 8px rgba(0, 0, 0, 0.2),\n    0 6px 20px rgba(0, 0, 0, 0.19);\n  z-index: 2;\n}\n.tableS-helpCard {\n  position: relative;\n  direction: ltr;\n  padding: 1vw;\n  margin: 1.25vw;\n  width: auto;\n  border: solid 1px #1a6a7c;\n  border-radius: 10px;\n  background: #ffffff;\n  -webkit-filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.4));\n  filter: drop-shadow(3px 3px 3px rgba(0, 0, 0, 0.4));\n  font-size: 1.5vw;\n}\n.tableS-cardCaption {\n  font-family: \"Amatic SC\";\n  font-size: 2vw;\n}\n.tableS-auxButtonshelp {\n  display: grid;\n  width: 50%;\n  grid-template-columns: repeat(3, auto);\n  gap: 0.5vw;\n  justify-self: center;\n}\n#tableS-modesCards::-webkit-scrollbar {\n  width: 0.5vw;\n}\n\n#tableS-modesCards::-webkit-scrollbar-thumb {\n  background: #cecece;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
